import { render, staticRenderFns } from "./PlaceAdd.vue?vue&type=template&id=19bf1a7b&scoped=true"
import script from "./PlaceAdd.vue?vue&type=script&lang=js"
export * from "./PlaceAdd.vue?vue&type=script&lang=js"
import style0 from "./PlaceAdd.vue?vue&type=style&index=0&id=19bf1a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf1a7b",
  null
  
)

export default component.exports